// hooks/useTenantGuard.js
import { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const useTenantGuard = () => {
  const [tenantEnabled, setTenantEnabled] = useState(() => {
    const value = cookies.get('tenantEnabled');
    // Default to true if undefined (first load)
    return value === true || value === 'true' || value === undefined;
  });

  // Get tenantId from cookies
  const getTenantId = () => {
    return cookies.get('defaulttenant') || cookies.get('tenantId') || null;
  };

  // Listen for tenant status changes from API interceptor
  useEffect(() => {
    const handler = (e) => setTenantEnabled(e.detail.tenantEnabled);
    window.addEventListener('tenantStatusChanged', handler);
    return () => window.removeEventListener('tenantStatusChanged', handler);
  }, []);

  const tenantId = getTenantId();
  
  // ✅ No tenantId in cookies = Super Admin = Never blocked
  const isSuperAdmin = !tenantId;
  
  // ✅ Super Admin is never blocked, Tenant users blocked if tenant inactive
  const isTenantBlocked = isSuperAdmin ? false : !tenantEnabled;

  // console.log("🛡️ useTenantGuard:", { 
  //   tenantId, 
  //   isSuperAdmin, 
  //   tenantEnabled, 
  //   isTenantBlocked 
  // });

  return {
    isTenantBlocked,
    isSuperAdmin,
    tenantEnabled,
    tenantId,
    tenantMessage: isTenantBlocked 
      ? 'Your tenant is inactive. This action is not allowed. Please contact administrator.' 
      : '',
  };
};